import { render } from "./GroupWise.vue?vue&type=template&id=0ab22fb8&scoped=true"
import script from "./GroupWise.vue?vue&type=script&lang=js"
export * from "./GroupWise.vue?vue&type=script&lang=js"

import "./GroupWise.vue?vue&type=style&index=0&id=0ab22fb8&lang=less&scoped=true"

import exportComponent from "D:\\benq\\dev-front\\design-competition\\2021\\design-competition-web-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ab22fb8"]])

export default __exports__